import React from 'react';
export function BdFlag({
  width = 28
}: {
  width?: number;
}) {
  return <svg width={width} height={width * 6 / 10} viewBox="0 0 10 6" role="img" aria-label="বাংলাদেশের জাতীয় পতাকা" className="rounded-[2px] shadow-sm shrink-0" data-id="element-98" data-mp="9993efzk3lgs">
      <rect width="10" height="6" fill="#006A4E" data-id="element-99" data-mp="nalf2f7op0wv" />
      <circle cx="4.5" cy="3" r="2" fill="#F42A41" data-id="element-100" data-mp="i9ea0nwxeftw" />
    </svg>;
}